import React from 'react';
import styles from './remove-font-overlay.scss';

import ubBanzai from 'ub/control/banzai-features';

class MaxFontsOverlay extends React.Component {
  constructor() {
    super();

    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    this.props.modalActionsSubject.onNext({type: 'closeMaxFontOverlay'});
  }

  render() {
    const FONT_MAX_NUM = ubBanzai.getFeatureValue('maximumNumberOfFonts');
    return (
      <div className={`${styles.overlay} modal-sheet asset-delete`}>
        <div className={styles.contentContainer}>
          <div className='warning-header-icon svg-ico-warning4' />

          <div className={styles.warningText}>
            <div className={styles.warningTitle}>
              {`Oops, that's too many fonts for one page. (The limit is ${FONT_MAX_NUM}.)`}
            </div>
            <div className={styles.warningMessage}>
              Remove some to make room for more fonts!
            </div>
          </div>

          <div className={styles.buttonsContainer}>
            <div className={styles.button} onClick={this.onClose}>
              OK
            </div>
          </div>

        </div>
      </div>
    );
  }
}

MaxFontsOverlay.propTypes = {modalActionsSubject: React.PropTypes.object};

export default MaxFontsOverlay;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/max-fonts-overlay.jsx